var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIlionxinline = function SvgIlionxinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 676,
    viewBox: "0 0 676 676"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ilionx_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676 0v676H0V0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ilionx_inline_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.885 0 219 258h-99.784L0 76.114 49.885 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ilionx_inline_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219 0 49.879 258 0 181.886 119.216 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ilionx_inline_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.057 0 223 325.5 9.057 651H0l213.936-325.5L0 0h9.057"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ilionx_inline_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.057 0 223 325.5 9.057 651H0l213.936-325.5L0 0h9.057"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ilionx_inline_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.057 0 223 325.5 9.057 651H0l213.936-325.5L0 0h9.057"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ilionx_inline_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.057 0 223 325.5 9.057 651H0l213.936-325.5L0 0h9.057"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ilionx_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ilionx_inline_svg__b)",
    transform: "translate(388 405)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8003C",
    d: "M0 0h219v258H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ilionx_inline_svg__c)",
    transform: "translate(388 12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8003C",
    d: "M0 0h219v258H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ilionx_inline_svg__d)",
    transform: "translate(160 12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8003C",
    d: "M0 0h223v651H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ilionx_inline_svg__d)",
    transform: "translate(137 12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8003C",
    d: "M0 0h223v651H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ilionx_inline_svg__e)",
    transform: "translate(115 12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8003C",
    d: "M0 0h223v651H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ilionx_inline_svg__f)",
    transform: "translate(92 12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8003C",
    d: "M0 0h223v651H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ilionx_inline_svg__g)",
    transform: "translate(70 12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8003C",
    d: "M0 0h223v651H0z"
  })))));
};
export default SvgIlionxinline;